import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
// import { useLocation } from "@reach/router";
// import { useStaticQuery, graphql } from "gatsby";

const SEO = ({ title, description, image, article, keywords }) => {
  const pathname = window.location.pathname;

  //const { pathname } = useLocation();
  //const { site } = useStaticQuery(query);

  const defaultTitle =
    "TheDigitalSpecs- Technique for selecting trending products";
  const titleTemplate = "%s | The Digital Specs";
  const defaultDescription =
    "Find top rated products, software and services based on in-depth features from verified users. Guide analyzes thousands of articles and customer reviews at today's lowest prices.";
  const siteUrl = "https://thedigitalspecs.in";
  const defaultImage =
    "https://images.pexels.com/photos/669996/pexels-photo-669996.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${image || defaultImage}`,
    url: `${siteUrl}${pathname}`,
  };

  return (
    <Helmet title={seo.title} titleTemplate={titleTemplate}>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.title} />
      {keywords && <meta name="keywords" content={keywords.join(", ")} />}
      <meta
        name="google-site-verification"
        content="I61UhoWRiuZJOcMs1KU2rUDvcULWmESLFoI-egR6bbY"
      />
      {seo.url && <meta property="og:url" content={seo.url} />}
      {(article ? true : null) && <meta property="og:type" content="article" />}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}
      {seo.image && <meta property="og:image" content={seo.title} />}
      {/* <meta name="twitter:card" content="summary_large_image" />

      {twitterUsername && (
        <meta name="twitter:creator" content={twitterUsername} />
      )}

      {seo.title && <meta name="twitter:title" content={defaultTitle} />}

      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}

      {seo.image && <meta name="twitter:image" content={seo.title} />} */}
    </Helmet>
  );
};

export default SEO;

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  article: PropTypes.bool,
};

SEO.defaultProps = {
  title: null,
  description: null,
  image: null,
  article: false,
};

// const query = graphql`
//   query SEO {
//     site {
//       siteMetadata {
//         defaultTitle: title
//         titleTemplate
//         defaultDescription: description
//         siteUrl: url
//         defaultImage: image
//         twitterUsername
//       }
//     }
//   }
// `;
